import { HttpResponse } from '@angular/common/http';
import {
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NotificationsService } from '@app/components/notification/NotificationsService';
import {
  BuFeature,
  CustomerActivityDao,
} from '@app/dao/customer-activity/customer-activity.dao';
import { SimulationDao } from '@app/dao/simulation/simulation.dao';
import { SimulationOwnerChoiceService } from '@app/dashboard/shared/simulation-owner-modal/simulation-owner-choice.service';
import { finalize, mergeMap, tap } from 'rxjs';

@Component({
  selector: 'ea-simulation-download',
  templateUrl: './ea-simulation-download.component.html',
  standalone: false,
})
export class EaSimulationDownloadComponent {
  @Input() simulation: any;
  @Input() label = 'Télécharger la simulation en PDF';
  @Input() icon = 'download';
  @Output() downloaded: EventEmitter<void> = new EventEmitter();
  @Output() loadingChange: EventEmitter<boolean> = new EventEmitter();

  canDownload$ = this.customerActivityDao.canUse$(
    BuFeature.SIMULATION_DOWNLOAD,
  );

  constructor(
    private customerActivityDao: CustomerActivityDao,
    private simulationDao: SimulationDao,
    private simulationOwnerChoice: SimulationOwnerChoiceService,
    private notificationsService: NotificationsService,
    private destroyRef: DestroyRef,
  ) {}

  download() {
    this.simulationOwnerChoice
      .choose(this.simulation)
      .pipe(
        tap(() => this.loadingChange.emit(true)),
        mergeMap(ownerIds =>
          this.simulationDao.download(this.simulation, ownerIds),
        ),
        finalize(() => this.loadingChange.emit(false)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe({
        next: (response: HttpResponse<Blob>) => this.save(response),
        error: () =>
          this.notificationsService.error('Une erreur est survenue.'),
      });
  }

  private save(response: HttpResponse<Blob>) {
    const filename = response.headers
      .get('content-disposition')
      ?.split('"')[1]
      ?.trim();
    if (!filename) return;
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(
      new Blob([response.body], { type: 'application/pdf' }),
    );
    link.download = filename;
    link.click();
    this.downloaded.emit();
  }
}
